import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faUser,
    faComments
} from '@fortawesome/free-solid-svg-icons';
import {
  faWeibo,
    faWeixin,
    faAlipay,
    faQq,
    faSlack,
    faPaypal,
    faTwitter
} from "@fortawesome/free-brands-svg-icons";

Vue.config.productionTip = false

import "../public/css/materialdesignicons.min.css";
import 'swiper/swiper-bundle.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue } from 'bootstrap-vue'
var VueScrollTo = require('vue-scrollto');
import Scrollspy from 'vue2-scrollspy';
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueMasonry from 'vue-masonry-css'
import axios from "axios";
import moment from 'moment'

Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})

Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)
Vue.use(VueMasonry)
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
    faUser,
    faWeibo,
    faWeixin,
    faAlipay,
    faQq,
    faSlack,
    faTwitter,
    faPaypal,
    faComments
);

// 添加请求公参
axios.defaults.withCredentials=true;
axios.interceptors.request.use((config) => {
  config.params = {
    locale: getLang(),
    ...config.params
  };
  return config;
});
Vue.filter('formatDate', function(value) {
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('formatDate2', function(value) {
  return moment(value).format('YYYY/MM/DD')
})

const i18n = new VueI18n({
  locale: getLang(),
  messages: {
    'zh' : require("./locale/zh/lang"),
    'en' : require('./locale/en/lang')
  }
})

function getLang() {
  let lang = "";
  // 先从url中读取参数
  const matches = location.href.match(/locale=(\w+)/);
  if (matches !== null && matches.length> 1) {
    lang = matches[1];
  } else {
    // 从cookie中读取设置的语言
    lang = Vue.$cookies.get("mirror-lang");
    if (lang === undefined || lang === null) {
      const language = navigator.language || navigator.userLanguage;//常规浏览器语言和IE浏览器
      lang = /zh/.test(language)? 'zh' : 'en';
    }
  }
  Vue.$cookies.set("mirror-lang", lang);
  document.body.className = lang;
  return lang;
}

Vue.prototype.getLang = getLang;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')

